import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import { useCurrentCustomerName, useCurrentSiteId } from "shared/composables/project";
import logger from "shared/services/logger";
import OculaiVideoPlayer from "@/components/other/OculaiVideoPlayer.vue";
import { useFullWindow4to3RatioDimensionStyle } from "@/composables/screen";
import StreamRepository from "@/repositories/StreamRepository";


export default /*#__PURE__*/_defineComponent({
  __name: 'PublicLive',
  setup(__props) {

const route = useRoute();
const currentCustomerName = useCurrentCustomerName();
const currentSiteId = useCurrentSiteId();

const videoUrl = ref<string | null>(null);
const loading = ref(false);

const fullWindow4to3RatioDimensionStyle = useFullWindow4to3RatioDimensionStyle();

onMounted(async () => {
  loading.value = true;
  try {
    const cameraId = route.params.camera_id as string;
    const token = route.params.token as string;
    videoUrl.value = await StreamRepository.loadPublicLiveUrl(
      currentCustomerName,
      currentSiteId,
      cameraId,
      token,
    );
  } catch (error) {
    logger.error(error);
    videoUrl.value = null;
  } finally {
    loading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle(_unref(fullWindow4to3RatioDimensionStyle))
  }, [
    _createVNode(OculaiVideoPlayer, {
      loading: loading.value,
      src: videoUrl.value,
      noSrcMessage: _ctx.$t('err.no_live_found'),
      hls: true
    }, null, 8, ["loading", "src", "noSrcMessage"])
  ], 4))
}
}

})